import React, { useState, useEffect } from 'react';
import {
  VehicleSelectorType,
  ICardInformation,
  ICardInformationBasic,
  ICardInformationComplex,
} from 'interfaces/requestAQuote';
import { useLoadImages } from 'hooks/useLoadImages';

import 'swiper/swiper-bundle.css';
import { VehicleCardBasic } from './VehicleCardBasic/VehicleCardBasic';
import { VehicleCardBasicCaption } from './VehicleCardBasicCaption/VehicleCardBasicCaption';
import { VehicleCardComplex } from './VehicleCardComplex/VehicleCardComplex';

export interface IVehicleCard {
  variant?: VehicleSelectorType;
  cardInfo?: ICardInformation;
}
export function VehicleCard({ variant, cardInfo }: IVehicleCard) {
  const [actualImage, setActualImage] = useState('');
  const cardInfoComplex = cardInfo as ICardInformationComplex;
  const cardInfoBasic = cardInfo as ICardInformationBasic;
  const defaultBasicImage = cardInfoBasic.img;
  const defaultComplexImage =
    cardInfoComplex && cardInfoComplex.images && cardInfoComplex.colors
      ? [
          ...(cardInfoComplex?.images as string[]),
          ...cardInfoComplex.colors.map(
            (color) => color.image.sources.small as unknown as string
          ),
        ]
      : [];
  let imageList = [];

  switch (variant) {
    case 'basic':
      imageList = [defaultBasicImage];
      break;
    case 'paymentEstimator':
      imageList = [defaultBasicImage];
      break;
    case 'offers':
      imageList = [defaultBasicImage];
      break;
    case 'bap':
      imageList = defaultComplexImage;
      break;
    case 'savedConfig':
      imageList = defaultComplexImage;
      break;
    case 'inventory':
      imageList = defaultComplexImage;
      break;
    default:
      imageList = [defaultBasicImage];
      break;
  }
  const { hasLoaded, hasError } = useLoadImages(imageList);

  useEffect(() => {
    if (hasLoaded && !hasError) {
      setActualImage(defaultBasicImage);
    }
  }, [hasLoaded, hasError, defaultBasicImage]);

  variant = variant ? variant : VehicleSelectorType.basic;
  const vehicleCardDictionary = {
    basic: (
      <VehicleCardBasic
        cardInfo={cardInfoBasic}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
    paymentEstimator: (
      <VehicleCardBasicCaption
        cardInfo={cardInfoBasic}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
    offers: (
      <VehicleCardBasicCaption
        cardInfo={cardInfoBasic}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
    bap: (
      <VehicleCardComplex
        cardInfo={cardInfoComplex}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
    savedConfig: (
      <VehicleCardComplex
        cardInfo={cardInfoComplex}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
    inventory: (
      <VehicleCardComplex
        cardInfo={cardInfoComplex}
        image={actualImage}
        imgLoaded={hasLoaded}
        imgError={hasError}
      />
    ),
  };

  return vehicleCardDictionary[variant];
}
